export * from './skyscanner-view.module';
